import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Login from "../pages/auth/Login";
import useAuthStore from "../store/useAuthStore";

const AuthGuard = ({ children }) => {
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!user?.id) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }

    return <Login />;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  if (user?.permission === "user" && location.pathname.startsWith("/admin")) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default AuthGuard;
